export default "__VITE_ASSET__DsXGpo7s__"